import React from 'react'
import ButtonBase from '@mui/material/ButtonBase'

/**
 * Story 175, CU5 (S85) -- the label of an eligible machine row of the Gantt, which opens its detail.
 * A real button (keyboard and screen reader reachable) that keeps the look of the label it replaces,
 * with a hand cursor and an underline on hover as the only hint that it can be pressed.
 */
const MachineRowLabel = ({ label, onClick }) => (
  <ButtonBase
    onClick={onClick}
    disableRipple
    data-testid='gantt-machine-label'
    sx={{
      font: 'inherit',
      color: 'inherit',
      textAlign: 'left',
      cursor: 'pointer',
      '&:hover, &:focus-visible': { textDecoration: 'underline' }
    }}
  >
    {label}
  </ButtonBase>
)

export default MachineRowLabel
